import { useCompany } from "#modules/company/view/useCompany";
import { useCompanyMachines } from "#modules/machines/view/useCompanyMachines";

export const useAreOptimizationsAvailable = () => {
  const { company } = useCompany();
  const { companyMachines } = useCompanyMachines();

  const hasOptimizableMachine = companyMachines.some((machine) => machine.canBeOptimized);

  return company?.companySettings.hasMultiPartNesting === true || hasOptimizableMachine;
};
